const initialState = {
  adminUsers: [],           // Array of all admin users
  allUsers: [],            // Array of all users
  adminUser: null,         // Single admin user for detail view
  isLoading: false,        // Loading state
  isError: false,          // Error state
  errorMessage: '',        // Error message
  adminUserUpdated: null,  // Updated admin user response
  adminUserCreated: null,  // Created admin user response
  adminUserDeleted: null,  // Deleted admin user response
  adminRoleUpdated: null,  // Role update response
};

export default function adminManagementReducer(state = initialState, action: any) {
  switch (action.type) {
    case 'GET_ALL_ADMIN_USERS':
      return { 
        ...state, 
        adminUsers: action.payload,
        adminUserDeleted: null,
        adminUserCreated: null,
        adminUserUpdated: null,
        adminRoleUpdated: null,
        errorMessage: '', 
        isError: false, 
        isLoading: false 
      };
    
    case 'GET_ALL_USERS':
      return { 
        ...state, 
        allUsers: action.payload,
        adminUserDeleted: null,
        adminUserCreated: null,
        adminUserUpdated: null,
        adminRoleUpdated: null,
        errorMessage: '', 
        isError: false, 
        isLoading: false 
      };
    
    case 'GET_ADMIN_USER':
      return { 
        ...state, 
        adminUser: action.payload, 
        errorMessage: '', 
        isError: false, 
        isLoading: false 
      };
    
    case 'UPDATE_ADMIN_USER':
      return { 
        ...state, 
        adminUserUpdated: action.payload, 
        errorMessage: '', 
        isError: false, 
        isLoading: false 
      };
    
    case 'CREATE_ADMIN_USER':
      return { 
        ...state, 
        adminUserCreated: action.payload, 
        errorMessage: '', 
        isError: false, 
        isLoading: false 
      };
    
    case 'DELETE_ADMIN_USER':
      return {
        ...state,
        adminUserDeleted: action.payload,
        errorMessage: '',
        isError: false,
        isLoading: false
      };
    
    case 'UPDATE_ADMIN_ROLE':
      return {
        ...state,
        adminRoleUpdated: action.payload,
        errorMessage: '',
        isError: false,
        isLoading: false
      };
    
    case 'ADMIN_MANAGEMENT_ACTION_STARTS':
      return { 
        ...state, 
        isLoading: true,
        adminUserCreated: null,
        adminUserUpdated: null,
        adminUserDeleted: null,
        adminRoleUpdated: null,
        isError: false,
        errorMessage: ''
      };
    
    case 'ADMIN_MANAGEMENT_ACTION_ERRORS':
      return { 
        ...state, 
        isError: true, 
        errorMessage: action.payload, 
        isLoading: false 
      };
    
    case 'RESET_ADMIN_MANAGEMENT_ERRORS':
      return { 
        ...state, 
        isError: false, 
        errorMessage: '',
      };
    
    default:
      return state;
  }
} 